export const SET_FORMS = 'SET_FORMS';
export const SET_FORM = 'SET_FORM';
export const ADD_FORM = 'ADD_FORM';
export const UPDATE_FORM = 'UPDATE_FORM';
export const REMOVE_FORM = 'REMOVE_FORM';
export const CLEAR_FORM = 'CLEAR_FORM';
export const CLEAR_FORMS = 'CLEAR_FORMS';
